import { Box } from '@mui/material'
import { memo } from 'react'

const TEXT_BLOCK_HEIGHT = 14

/** Structure-only placeholder for predefined strategy tiles shimmer. */
function StrategyTilesSkeleton() {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                gap: 2,
                p: 2,
                width: '100%',
                height: '100%'
            }}
        >
            {[...Array(8)].map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1,
                        p: 2,
                        minHeight: 100
                    }}
                >
                    <Box sx={{ height: 40, width: 40, borderRadius: 1 }} />
                    <Box sx={{ height: TEXT_BLOCK_HEIGHT, width: i % 2 === 0 ? 80 : 64 }} />
                </Box>
            ))}
        </Box>
    )
}

export default memo(StrategyTilesSkeleton)
